import { CommonModule, NgComponentOutlet } from '@angular/common';
import { Component, input, Type, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'siat-shared-popover',
   
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    NgComponentOutlet,
  ],
  templateUrl: './popover.component.html',
})
export class SharedPopoverComponent {
  /**
   * The popover component.
   */
  contentComponent = input.required<Type<unknown>>();

  /**
   * Optional content data.
   */
  contentData = input<unknown>();

  /**
   * Reference.
   */
  private readonly menuTrigger = viewChild.required(MatMenuTrigger);

  /**
   * Trigger menu open.
   */
  openPopover(): void {
    this.menuTrigger().openMenu();
  }

  /**
   * Create data input.
   */
  protected get componentInputs() {
    const data = this.contentData();
    if (!data) return {};

    return { data: data };
  }
}
